import { ChangeDetectionStrategy, Component } from '@angular/core';
import { ITooltipAngularComp } from 'ag-grid-angular';

@Component({ standalone: false, selector: 'tooltip-component',
  template: `
    <div class="custom-tooltip">
      <p>
        <span>{{ data.nExtras }} Extras</span>
      </p>
    </div>
  `,
  changeDetection: ChangeDetectionStrategy.OnPush,
  styles: [
    `
      .custom-tooltip p {
        margin: 5px;
        white-space: nowrap;
      }

      .custom-tooltip p:first-of-type {
        font-weight: bold;
      }
    `
  ]
})
export class AGCustomTooltip implements ITooltipAngularComp {
  public params: any;
  public data: any;

  agInit(params): void {
    this.params = params;
    this.data = params.api.getDisplayedRowAtIndex(params.rowIndex).data;
  }
}
